jQuery(document).ready(function () {
  jQuery(".accordion-content").on("show.bs.collapse", function () {
    // var id = jQuery(this).attr("data-service-id");

    // Hide all asides
    //jQuery(".card-aside").removeClass('inplace');

    // Show this aside
    //jQuery("#card-aside-" + id).addClass('inplace');

    var element_id = jQuery(this).attr("id");
    console.log(element_id);
    // This accordion
    var this_accordion_id = jQuery(this).attr("data-parent"); // has hash

    // Fidn the parent card and add active to it.
    jQuery(this_accordion_id + " .card").removeClass("active");
    jQuery(this_accordion_id + " .card").removeClass("inplace");
    jQuery("#" + element_id)
      .parent()
      .parent()
      .addClass("active");

    // Add inplace after .2 seconds
    setTimeout(function () {
      jQuery("#" + element_id)
        .parent()
        .parent()
        .addClass("inplace");
    }, 220);
  });

  // Add data-featherlight="image" to the first link in each grid item.

  jQuery(".lightbox-grid").each(function (index, element) {
    jQuery(element)
      .find(".grid-item")
      .each(function (index2, element2) {
        // Do something with each inner element
        jQuery(element2).find("a").first().attr("data-featherlight", "image");
      });
  });
});

(function () {
  function runHeroWordAnim() {
    var h1 = document.querySelector(".home-hero h1");
    if (!h1) return;

    var text = (h1.textContent || h1.innerText || "")
      .replace(/\s+/g, " ")
      .trim();
    if (!text) return;

    var words = text.split(" ");
    var html = "";
    for (var i = 0; i < words.length; i++) {
      html +=
        '<span class="word">' +
        words[i] +
        "</span>" +
        (i < words.length - 1 ? " " : "");
    }
    h1.innerHTML = html;

    if (typeof TweenMax !== "undefined") {
      TweenMax.set(h1, { opacity: 1 });
    } else {
      h1.style.opacity = "1";
      h1.style.visibility = "visible";
    }

    var nodeList = h1.querySelectorAll(".word");
    var spans = [];
    for (var j = 0; j < nodeList.length; j++) {
      spans.push(nodeList[j]);
      nodeList[j].style.display = "inline-block";
    }

    if (typeof TweenMax === "undefined" || typeof TimelineMax === "undefined")
      return;

    TweenMax.killTweensOf(spans);
    TweenMax.set(spans, { autoAlpha: 0, y: 16 });

    var tl = new TimelineMax();
    tl.staggerTo(
      spans,
      0.7,
      { autoAlpha: 1, y: 0, ease: Power3.easeOut, overwrite: "auto" },
      0.06
    );
  }

  // Run after everything is loaded (more reliable on WP), and also on next paint
  window.addEventListener("load", function () {
    requestAnimationFrame(function () {
      requestAnimationFrame(runHeroWordAnim);
    });
  });
})();

// Scroll pin feature
window.addEventListener("load", function () {
  if (!window.gsap || !window.ScrollTrigger) {
    console.warn("GSAP/ScrollTrigger not loaded.");
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  var media = document.querySelector(".scroll-block1 .col-first .inner");
  var section2 = document.querySelector(".scroll-block2");
  var header = document.querySelector(".headroom"); // adjust selector if needed

  if (!media || !section2) return;

  function scrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function headerH() {
    return header ? header.offsetHeight : 0;
  }

  function docTop(el) {
    var r = el.getBoundingClientRect();
    return r.top + scrollY();
  }

  function calcDistance() {
    // Use an inner element to avoid margin-collapse weirdness on the section
    var s2Anchor = section2.querySelector(".container-fluid") || section2;

    var mediaH = media.getBoundingClientRect().height;
    var mediaTop = docTop(media);

    var s2Top = docTop(s2Anchor);
    var s2H = section2.getBoundingClientRect().height;

    // Top position needed to vertically center the media in section 2
    var targetTop = s2Top + (s2H - mediaH) / 2;

    // IMPORTANT: no "- headerH()" here
    var dist = targetTop - mediaTop;

    return dist > 0 ? dist : 0;
  }

  ScrollTrigger.create({
    trigger: media, // <-- key change: trigger off the pinned element
    start: function () {
      return "top top+=" + headerH();
    },
    end: function () {
      return "+=" + calcDistance();
    },
    pin: media,
    pinSpacing: true,
    anticipatePin: 1,
    invalidateOnRefresh: true,
    // markers: true
  });

  ScrollTrigger.refresh();

  // Re-refresh after the image loads (common cause of “off by a bit”)
  var img = media.querySelector("img");
  if (img && !img.complete) {
    img.addEventListener("load", function () {
      ScrollTrigger.refresh();
    });
  }

  window.addEventListener("resize", function () {
    ScrollTrigger.refresh();
  });
});

window.addEventListener("load", function () {
  if (!window.gsap || !window.ScrollTrigger || !window.imagesLoaded) {
    console.warn("Missing gsap / ScrollTrigger / imagesLoaded.");
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  function initInnerReveal(inner) {
    var img = inner.querySelector("img");
    if (!img) return;

    gsap.set(inner, { opacity: 1, clipPath: "inset(0% 0% 100% 0%)" });
    gsap.set(img, { opacity: 0, scale: 1.06 });

    // Optional: reveal nearby text in the same row
    var textTargets = [];
    var row = inner.closest(".row") || inner.parentNode;
    if (row) {
      var els = row.querySelectorAll("h1,h2,h3,p,li,.wp-block-button");
      for (var i = 0; i < els.length; i++) {
        if (els[i].closest(".inner") === inner) continue;
        textTargets.push(els[i]);
      }
    }

    var tl = gsap.timeline({
      paused: true,
      defaults: { ease: "power3.out" },
    });

    tl.to(inner, { clipPath: "inset(0% 0% 0% 0%)", duration: 0.9 }, 0);
    tl.to(img, { opacity: 1, scale: 1, duration: 1.0 }, 0.05);

    if (textTargets.length) {
      tl.fromTo(
        textTargets,
        { autoAlpha: 0, y: 18 },
        { autoAlpha: 1, y: 0, duration: 0.55, stagger: 0.06 },
        0.25
      );
    }

    // Wait for image to load before allowing reveal
    imagesLoaded(img, function () {
      ScrollTrigger.create({
        trigger: inner,
        start: "top 80%",
        once: true,
        onEnter: function () {
          tl.play(0);
        },
      });
    });
  }

  function boot() {
    var inners = document.querySelectorAll(".projects-header .inner");
    for (var i = 0; i < inners.length; i++) {
      initInnerReveal(inners[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
});


// Animate projects list page
window.addEventListener("load", function () {
  console.log("Animating");
  if (!window.gsap) {
    console.warn("GSAP not found");
    return;
  }

  // Your template row has BOTH classes on the same node
  var itemSelector = ".facetwp-template.projects-row > [class*='col-']";

  function animateProjectsGrid() {
    var items = document.querySelectorAll(itemSelector);
    if (!items || !items.length) return;

    gsap.killTweensOf(items);
    gsap.set(items, { autoAlpha: 0, y: 18 });

    if (window.imagesLoaded) {
      imagesLoaded(items, function () {
        gsap.to(items, {
          autoAlpha: 1,
          y: 0,
          duration: 0.7,
          ease: "power3.out",
          stagger: { each: 0.07, from: "start" },
        });
      });
    } else {
      gsap.to(items, {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out",
        stagger: { each: 0.07, from: "start" },
      });
    }
  }

  // Initial
  jQuery(function () {
    animateProjectsGrid();
  });

  // After FacetWP refresh
  jQuery(document).on("facetwp-loaded", function () {
    // next tick after DOM swap
    setTimeout(function () {
      animateProjectsGrid();
    }, 0);
  });
});




// Put this in a global JS file or inline (footer is fine)
window.addEventListener("load", function () {
document.addEventListener('facetwp-loaded', function () {
  // Close all fSelect dropdowns
  if (typeof fUtil !== 'undefined') {
    fUtil('.facetwp-type-fselect .facetwp-dropdown').each(function () {
      // FacetWP attaches the fSelect instance to the dropdown node
      if (this.fselect && typeof this.fselect.close === 'function') {
        this.fselect.close();
      }
    });
  } else {
    // Fallback if fUtil isn't available for some reason
    var els = document.querySelectorAll('.facetwp-type-fselect .facetwp-dropdown');
    for (var i = 0; i < els.length; i++) {
      if (els[i].fselect && typeof els[i].fselect.close === 'function') {
        els[i].fselect.close();
      }
    }
  }
});
});




window.addEventListener("load", function () {
  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  // Target each slider instance
  document.querySelectorAll(".projects-client-slider .swiper").forEach(function (swiperEl) {
    var slides = swiperEl.querySelectorAll(".swiper-slide");
    if (!slides.length) return;

    // Set initial state (in case CSS didn't load yet)
    gsap.set(slides, { autoAlpha: 0, y: 16 });

    ScrollTrigger.create({
      trigger: swiperEl,
      start: "top 80%",
      once: true,
      onEnter: function () {
        gsap.to(slides, {
          autoAlpha: 1,
          y: 0,
          duration: 0.6,
          ease: "power3.out",
          stagger: 0.08,
          clearProps: "transform"
        });
      }
    });
  });
});


// Make tabbed content have the same height.
window.addEventListener("load", function () {
  document.querySelectorAll(".tabbed-content.tabs-eq-height .bs-tabs.accordion").forEach(function (acc) {
    var panes = acc.querySelectorAll(".card .collapse"); // the collapsible wrappers
    if (!panes.length) return;

    var max = 0;

    panes.forEach(function (pane) {
      var body = pane.querySelector(".card-body");
      if (!body) return;

      // Save original inline styles + show state
      var wasShown = pane.classList.contains("show");
      var prevStyle = pane.getAttribute("style");

      // Make it measurable without flashing
      pane.classList.add("show");
      pane.style.display = "block";
      pane.style.height = "auto";
      pane.style.visibility = "hidden";
      pane.style.position = "absolute";
      pane.style.pointerEvents = "none";
      pane.style.left = "-99999px";
      pane.style.top = "0";

      // Measure natural content height
      var h = body.scrollHeight;
      if (h > max) max = h;

      // Restore state
      if (!wasShown) pane.classList.remove("show");
      if (prevStyle !== null) {
        pane.setAttribute("style", prevStyle);
      } else {
        pane.removeAttribute("style");
      }
    });

    // Apply min-height to all bodies
    acc.querySelectorAll(".card .card-body").forEach(function (b) {
      b.style.minHeight = max + "px";
    });
  });
});



// Swiper progress bullet feature.
function restartActiveBulletAnimation(swiper) {
  var bullets = swiper.el.querySelectorAll('.swiper-pagination-bullet');
  if (!bullets.length) return;

  // Remove animation by toggling a class is messy; easiest is reflow trick:
  bullets.forEach(function (b) {
    // remove animation by forcing it to reset
    b.classList.remove('is-animating');
  });

  var active = swiper.el.querySelector('.swiper-pagination-bullet-active');
  if (!active) return;

  // Force reflow then re-add class to restart animation
  // (works even if the same bullet becomes active again)
  void active.offsetWidth;
  active.classList.add('is-animating');
}













document.addEventListener("DOMContentLoaded", function () {
  var el = document.querySelector(".footer-rotator .rotate-word");
  if (!el) return;

  var words = ["Execution", "Results", "People", "Process"];
  var i = 0;

  // If the initial word matches one of the list items, start after it
  var startIndex = words.indexOf(el.textContent.trim());
  if (startIndex >= 0) i = startIndex;

  function nextWord() {
    i = (i + 1) % words.length;

    el.classList.add("is-changing");

    setTimeout(function () {
      el.textContent = words[i];
      el.classList.remove("is-changing");
    }, 250); // match CSS transition
  }

  setInterval(nextWord, 2000);
});



// Auto image slideshow.
document.addEventListener("DOMContentLoaded", function () {
function initSlideshow(container) {
    var inner = container.querySelector(".inner");
    if (!inner) return;

    var imgs = inner.querySelectorAll("img");
    if (!imgs || imgs.length < 2) return;

    if (inner.offsetHeight === 0) {
      inner.style.minHeight = "320px";
    }

    // Config
    var displayMs = 3200;  // time between slide changes
    var fadeMs = 900;      // crossfade duration
    var zoomFrom = 1.02;
    var zoomTo = 1.10;

    // Prep
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].style.opacity = "0";
      imgs[i].style.transform = "scale(" + zoomFrom + ")";
      imgs[i].style.willChange = "opacity, transform";
      imgs[i].style.pointerEvents = "none";
    }

    var current = 0;
    var resetTimers = new WeakMap();

    function clearResetTimer(img) {
      var t = resetTimers.get(img);
      if (t) {
        clearTimeout(t);
        resetTimers.delete(img);
      }
    }

    function activate(img) {
      clearResetTimer(img);

      // Start from zoomFrom, then zoom up while visible
      img.style.transition = "none";
      img.style.transform = "scale(" + zoomFrom + ")";
      img.offsetHeight; // reflow

      img.style.transition =
        "opacity " + fadeMs + "ms ease, transform " + displayMs + "ms linear";
      img.style.opacity = "1";
      img.style.transform = "scale(" + zoomTo + ")";
    }

    function deactivate(img) {
      clearResetTimer(img);

      // Fade out ONLY. Do NOT change transform here (prevents the shrink snap).
      img.style.transition = "opacity " + fadeMs + "ms ease";
      img.style.opacity = "0";

      // After fade completes, reset zoom so it's ready next time (invisible reset)
      var timer = setTimeout(function () {
        img.style.transition = "none";
        img.style.transform = "scale(" + zoomFrom + ")";
      }, fadeMs + 30);

      resetTimers.set(img, timer);
    }

    function showInitial() {
      for (var k = 0; k < imgs.length; k++) {
        imgs[k].style.transition = "none";
        imgs[k].style.opacity = "0";
        imgs[k].style.transform = "scale(" + zoomFrom + ")";
      }
      inner.offsetHeight;

      activate(imgs[current]);
    }

    function next() {
      var prev = current;
      current = (current + 1) % imgs.length;

      activate(imgs[current]); // fades/zooms in
      deactivate(imgs[prev]);  // fades out without transform snap
    }

    // Start after first image is ready
    if (imgs[0].complete) {
      showInitial();
    } else {
      imgs[0].addEventListener("load", showInitial, { once: true });
    }

    setInterval(next, displayMs);
  }

  function boot() {
    var slideshows = document.querySelectorAll(".image-auto-slideshow");
    for (var i = 0; i < slideshows.length; i++) {
      initSlideshow(slideshows[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
});